import React, { useState, useEffect } from "react";
import MileageInput from "../MileageInput";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import moment from "moment";

export default function Main({ token, destroyToken }) {
  const [specificData, setSpecificData] = useState({});
  const [isInsert, setIsInsert] = useState(true);
  const [id, setId] = useState(0);
  const [insertDate, setInsertDate] = useState("");
  const [motorbike, setMotorbike] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [place, setPlace] = useState("");
  const [price, setPrice] = useState(0);
  const [type, setType] = useState("");
  const [volume, setVolume] = useState(0);
  const [mileage, setMileage] = useState(0);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [placeOptions, setPlaceOptions] = useState([]);
  const [fuelCapacity, setFuelCapacity] = useState(0);
  const [fuelConsumption, setFuelConsumption] = useState(0);
  const [previousFuelConsumption, setPreviousFuelConsumption] = useState(0);
  const [startMileage, setStartMileage] = useState(0);
  const [mileageSincePurchase, setMileageSincePurchase] = useState(0);
  const [mileageDifference, setMileageDifference] = useState(0);
  const [averagePrice, setAveragePrice] = useState(0);
  const [averageFuelConsumption, setAverageFuelConsumption] = useState(0);
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => loadData(), []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => loadData(motorbike), [motorbike]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (specificData.length > 0) {
      setMileageDifference(mileage - specificData[0].acf.mileage);
    }
  }, [mileage, specificData]);

  useEffect(() => {
    if (specificData.length > 0) {
      let totalPrice = 0;
      let totalVolume = 0;
      specificData.forEach(function (item) {
        totalPrice += Number(item.acf.price);
        totalVolume += Number(item.acf.volume);
      });
      setAveragePrice((totalPrice / totalVolume).toFixed(3));
      setMileageSincePurchase(specificData[0].acf.mileage - startMileage);
      setAverageFuelConsumption(((specificData[0].acf.mileage - startMileage) / totalVolume).toFixed(3));
    }
  }, [startMileage, specificData]);

  useEffect(() => {
    if (mileageDifference !== 0) {
      setFuelConsumption((mileageDifference / volume).toFixed(3));
    } else {
      setFuelConsumption(previousFuelConsumption);
    }
  }, [mileageDifference, volume, previousFuelConsumption]);

  useEffect(() => {
    if (specificData.length > 0) {
      setId(specificData[0].id);
      setInsertDate(specificData[0].date);
      setCompany(specificData[0].acf.company);
      setCountry(specificData[0].acf.country);
      setPlace(specificData[0].acf.place);
      setPrice(Number(specificData[0].acf.price).toFixed(2));
      setType(specificData[0].acf.type);
      setVolume(Number(specificData[0].acf.volume).toFixed(2));
      setMileage(Number(specificData[0].acf.mileage));
      setFuelConsumption(((specificData[0].acf.mileage - specificData[1].acf.mileage) / specificData[0].acf.volume).toFixed(3));
      setPreviousFuelConsumption(((specificData[0].acf.mileage - specificData[1].acf.mileage) / specificData[0].acf.volume).toFixed(3));
      if (motorbike === "Z400") {
        setFuelCapacity(14);
        setStartMileage(16710);
      }
      if (motorbike === "Versys 650") {
        setFuelCapacity(21);
        setStartMileage(23514);
      }
    }
  }, [specificData]);

  const loadData = (motorbikeInput = "") => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/wp-json/wp/v2/fuel-costs?per_page=1000", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        if (motorbikeInput === "") {
          setMotorbike(response.data[0].acf.motorbike);
          setSpecificData(response.data.filter((item) => item.acf.motorbike === motorbike));
        } else {
          setSpecificData(response.data.filter((item) => item.acf.motorbike === motorbike));
        }
        let uniqueCompanies = [...new Set(response.data.map((item) => item.acf.company))].sort();
        setCompanyOptions(uniqueCompanies);
        let uniqueCountries = [...new Set(response.data.map((item) => item.acf.country))].sort();
        setCountryOptions(uniqueCountries);
        let uniquePlaces = [...new Set(response.data.map((item) => item.acf.place))].sort();
        setPlaceOptions(uniquePlaces);
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data.message === "Expired token") {
          destroyToken();
        } else {
          console.log(error);
        }
      });
  };

  const increase = (e, index) => {
    e.preventDefault();
    setMileage((prev) => {
      let number = Number(prev);
      const digitPosition = String(Math.trunc(Math.abs(number))).length - 1 - index;
      number += 10 ** digitPosition;
      return number;
    });
  };

  const decrease = (e, index) => {
    e.preventDefault();
    setMileage((prev) => {
      let number = Number(prev);
      const digitPosition = String(Math.trunc(Math.abs(number))).length - 1 - index;
      number -= 10 ** digitPosition;
      return number;
    });
  };

  const save = () => {
    setVolume(Number(volume).toFixed(2));
    setPrice(Number(price).toFixed(2));
    let postData = {
      title: moment().format("DD/MM/YYYY") + " - " + company + " - " + place + " - " + volume + " L - &euro;" + price + " - " + motorbike + " - " + mileage + " km",
      status: "publish",
      fields: {
        date: moment().format("YYYYMMDD"),
        type: type,
        motorbike: motorbike,
        company: company,
        country: country,
        place: place,
        volume: volume,
        price: price,
        mileage: mileage,
      },
    };

    if (isInsert) {
      axios
        .post(process.env.REACT_APP_API_BASE_URL + "/wp-json/wp/v2/fuel-costs", postData, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then(() => {
          loadData(motorbike);
          setResponseMessage("Data saved!");
        })
        .catch((error) => {
          setResponseMessage(error);
        });
    } else {
      axios
        .put(process.env.REACT_APP_API_BASE_URL + "/wp-json/wp/v2/fuel-costs/" + id, postData, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then(() => {
          loadData(motorbike);
          setIsInsert(true);
          setResponseMessage("Data updated!");
        })
        .catch((error) => {
          setResponseMessage(error);
        });
    }

    // Remove message after some time
    setTimeout(() => {
      setResponseMessage("");
    }, 2000);
  };

  const toggle = () => {
    setIsInsert(!isInsert);
  };

  const dataChanged = () => {
    if (company !== specificData[0].acf.company) {
      return true;
    }
    if (country !== specificData[0].acf.country) {
      return true;
    }
    if (place !== specificData[0].acf.place) {
      return true;
    }
    if (price !== specificData[0].acf.price) {
      return true;
    }
    if (type !== specificData[0].acf.type) {
      return true;
    }
    if (volume !== specificData[0].acf.volume) {
      return true;
    }
    if (!isInsert && mileage !== Number(specificData[0].acf.mileage)) {
      return true;
    }
  };

  const safeNumber = (value, decimals = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? number.toFixed(decimals) : "—";
  };

  return (
    <main className="app-shell">
      <header className="app-header">
        <div className="brand">
          <div className="brand-mark" aria-hidden="true">
            ↗
          </div>
          <div>
            <p className="eyebrow">RideGauge</p>
            <h1>Fuel tracker</h1>
          </div>
        </div>
        <div className="header-actions">
          <Button className={`mode-button ${!isInsert ? "is-edit" : ""}`} onClick={toggle}>
            {isInsert ? "New entry" : "Editing"}
          </Button>
          <Button className="logout-button" onClick={destroyToken} aria-label="Log out">
            ↪
          </Button>
        </div>
      </header>

      <section className="dashboard-card">
        <div className="dashboard-hero">
          <div className="motorbike-toggle" role="group" aria-label="Select motorbike">
            {["Z400", "Versys 650"].map((bike) => (
              <button key={bike} type="button" className={motorbike === bike ? "active" : ""} aria-pressed={motorbike === bike} onClick={() => setMotorbike(bike)}>
                {bike}
              </button>
            ))}
          </div>
          <div className="hero-meta">
            <div>
              <p className="eyebrow">Last entry</p>
              <p className="hero-date">{insertDate ? moment(insertDate).format("DD MMMM YYYY") : "No date yet"}</p>
              <p className="hero-relative">{insertDate ? moment(insertDate, "YYYYMMDD, hh:mm:ss").fromNow() : "Choose a motorbike to begin"}</p>
            </div>
            <div className="distance">
              <strong>{mileageSincePurchase || 0} km</strong>
              <span>{mileageDifference !== 0 ? `${mileageDifference > 0 ? "+" : ""}${mileageDifference} this tank` : "total distance"}</span>
            </div>
          </div>
          <MileageInput mileage={mileage} increase={increase} decrease={decrease} />
        </div>

        <Form className="entry-form">
          <p className="form-section-title">Fuel stop details</p>
          <div className="form-grid">
            <Form.Group>
              <Form.Label>Company</Form.Label>
              <Form.Control type="text" list="company_data" value={company} onChange={(e) => setCompany(e.target.value)} />
              <datalist id="company_data">
                {companyOptions.map((item) => (
                  <option key={item} value={item} />
                ))}
              </datalist>
            </Form.Group>
            <Form.Group>
              <Form.Label>Country</Form.Label>
              <Form.Control type="text" list="country_data" value={country} onChange={(e) => setCountry(e.target.value)} />
              <datalist id="country_data">
                {countryOptions.map((item) => (
                  <option key={item} value={item} />
                ))}
              </datalist>
            </Form.Group>
            <Form.Group className="field-wide">
              <Form.Label>Place</Form.Label>
              <Form.Control type="text" list="place_data" value={place} onChange={(e) => setPlace(e.target.value)} />
              <datalist id="place_data">
                {placeOptions.map((item) => (
                  <option key={item} value={item} />
                ))}
              </datalist>
            </Form.Group>
            <Form.Group>
              <Form.Label>Total price</Form.Label>
              <InputGroup>
                <InputGroup.Text id="price">€</InputGroup.Text>
                <Form.Control aria-label="Price" aria-describedby="price" type="number" step="0.01" value={price} onChange={(e) => setPrice(e.target.value)} />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <Form.Label>Fuel type</Form.Label>
              <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
                <option value="E5">E5</option>
                <option value="E10">E10</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="field-wide">
              <Form.Label>Volume</Form.Label>
              <InputGroup>
                <Form.Control aria-label="Volume" aria-describedby="volume" type="number" step="0.01" value={volume} onChange={(e) => setVolume(e.target.value)} />
                <InputGroup.Text id="volume">L</InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </div>
          {(mileageDifference !== 0 || !isInsert) && dataChanged() && (
            <Button className="save-button w-100" onClick={save}>
              {isInsert ? "Save fuel stop" : "Update fuel stop"}
            </Button>
          )}
          {responseMessage && (
            <p className="response-message" role="status">
              {String(responseMessage)}
            </p>
          )}
        </Form>

        <div className="stats-section">
          <p className="form-section-title">Ride insights</p>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">◒</div>
              <span>Efficiency</span>
              <strong>{safeNumber(fuelConsumption, 1)} km/L</strong>
              <small>avg {safeNumber(averageFuelConsumption, 1)} km/L</small>
            </div>
            <div className="stat-card">
              <div className="stat-icon">€</div>
              <span>Price / L</span>
              <strong>€ {safeNumber(price / volume, 3)}</strong>
              <small>avg € {safeNumber(averagePrice, 3)}</small>
            </div>
            <div className="stat-card">
              <div className="stat-icon">↗</div>
              <span>Range</span>
              <strong>{safeNumber(fuelConsumption * (fuelCapacity - 0.5))} km</strong>
              <small>to {safeNumber(fuelConsumption * (fuelCapacity - 0.5) + Number(mileage))} km</small>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
